import Ajv2020 from "ajv/dist/2020.js";
import contentSchema from "../../public/lp-content/content.schema.json";
import type { SelectedProposalV1 } from "../../public/lp-content/generator";
import proposalSchema from "../../public/lp-content/proposal.schema.json";

const ajv = new Ajv2020({ allErrors: true, strict: true });
ajv.addSchema({ ...contentSchema, $id: "content.schema.json" });
const validate = ajv.compile(proposalSchema);

export function parseProposal(content: string): SelectedProposalV1 | null {
	let parsed: unknown;
	try {
		parsed = JSON.parse(content);
	} catch {
		return null;
	}
	return validate(parsed) ? (parsed as SelectedProposalV1) : null;
}
